<template>
 <v-tabs>
      <v-tabs-bar>
        <v-tabs-item
          v-for="i in navItems"
          :key="i.text"
          :href="'#tab-' + i.text"
        >
          {{ i.text }}
        </v-tabs-item>
      </v-tabs-bar>
    </v-tabs>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";

.cardType {
  color: #ffffff;
  background-color: $amaze-teal;
}
.username {
  font-weight: bold;
}
</style>

<script>
export default {
  props: ["tabItems"],
  mounted() {
    // this.items = this.tabItems;
    console.log(this.navItems);
  },
  data() {
    return {
      navItems: [{ text: "Hello" }]
    };
  }
};
</script>
